import { useT } from '@hooks';
import React from 'react';
import checkTheme from '../../../../../../src/utils/custom/checkTheme';

import s from './index.module.scss';

function Reviews() {
	const { T } = useT();
	return (
		<div className={`${s.reviews} ${s[checkTheme()]}`}>
			<h2 className={s.reviewsTitle}>{T('users_love')}</h2>
			<ul className={s.reviewItems}>
				<li className={s.reviewItem}>
					<section className={s.reviewSingle}>
						<div className={s.reviewSingleHeader}>
							<h2 className={s.reviewSingleTitle}>{T('alternative_review_title_1')}</h2>
							<span className={s.reviewSingleAuthor}>{T('alternative_review_name_1')}</span>
						</div>
						<svg className={s.reviewSingleStars} viewBox='0 0 96 16'>
							<path
								className={s.reviewSingleStar}
								d='M8.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L8.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M48.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L48.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M28.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L28.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M67.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L67.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M87.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L87.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
						</svg>
						<p className='reviewSingleDescription'>{T('alternative_review_contentent_1')}</p>
					</section>
				</li>
				<li className={s.reviewItem}>
					<section className={s.reviewSingle}>
						<div className={s.reviewSingleHeader}>
							<h2 className={s.reviewSingleTitle}>{T('review_title')}</h2>
							<span className={s.reviewSingleAuthor}>{T('review_author')}</span>
						</div>
						<svg className={s.reviewSingleStars} viewBox='0 0 96 16'>
							<path
								className={s.reviewSingleStar}
								d='M8.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L8.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M48.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L48.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M28.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L28.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M67.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L67.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M87.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L87.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
						</svg>
						<p className='reviewSingleDescription'>{T('review_text')}</p>
					</section>
				</li>
				<li className={s.reviewItem}>
					<section className={s.reviewSingle}>
						<div className={s.reviewSingleHeader}>
							<h2 className={s.reviewSingleTitle}>{T('alternative_review_title_2')}</h2>
							<span className={s.reviewSingleAuthor}>{T('alternative_review_name_2')}</span>
						</div>
						<svg className={s.reviewSingleStars} viewBox='0 0 96 16'>
							<path
								className={s.reviewSingleStar}
								d='M8.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L8.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M48.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L48.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M28.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L28.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M67.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L67.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
							<path
								className={s.reviewSingleStar}
								d='M87.5 12.75l-4.996 2.627.954-5.564-4.042-3.94 5.586-.811L87.5 0l2.498 5.062 5.586.811-4.042 3.94.954 5.564z'
							/>
						</svg>
						<p className='reviewSingleDescription'>{T('alternative_review_contentent_2')}</p>
					</section>
				</li>
			</ul>
		</div>
	);
}

export default Reviews;
